import React, { useState, useEffect } from 'react';
import axios from 'axios';

const durumRenk = { bekliyor: 'badge-bekliyor', onaylandi: 'badge-tamamlandi', reddedildi: 'badge-hata' };
const durumEtiket = { bekliyor: 'Bekliyor', onaylandi: 'Onaylandı', reddedildi: 'Reddedildi' };

const IzinOnayPage = () => {
  const [izinler, setIzinler] = useState([]);
  const [filtre, setFiltre] = useState('bekliyor');
  const [kararPanel, setKararPanel] = useState(null);
  const [onayNotu, setOnayNotu] = useState('');
  const [sonuc, setSonuc] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);

  const yukle = () => axios.get('/api/personel/izinler/hepsi').then(r => setIzinler(r.data)).catch(console.error);
  useEffect(() => { yukle(); }, []);

  const handleKarar = async (id, durum) => {
    setYukleniyor(true); setSonuc(null);
    try {
      await axios.put('/api/personel/izinler/' + id + '/karar', { durum, onay_notu: onayNotu });
      setSonuc({ tip: 'basari', mesaj: durum === 'onaylandi' ? 'İzin onaylandı.' : 'İzin reddedildi.' });
      setKararPanel(null);
      setOnayNotu('');
      yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata oluştu.' }); }
    finally { setYukleniyor(false); }
  };

  const fmt = (t) => t ? new Date(t).toLocaleDateString('tr-TR') : '-';
  const filtrelenmis = izinler.filter(i => filtre === 'hepsi' ? true : i.durum === filtre);

  return (
    <div>
      <div style={{ marginBottom: '1.5rem' }}>
        <h2 style={{ fontSize: '22px', marginBottom: '4px' }}>İzin Onay Yönetimi</h2>
        <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>Personel izin taleplerini onaylayın veya reddedin.</p>
      </div>

      {sonuc && <div className={'alert alert-' + (sonuc.tip === 'basari' ? 'success' : 'error')} style={{ marginBottom: '1rem' }}>{sonuc.mesaj}</div>}

      <div className="stats-grid" style={{ marginBottom: '1.5rem' }}>
        <div className="stat-kart"><div className="stat-sayi">{izinler.filter(i => i.durum === 'bekliyor').length}</div><div className="stat-etiket">Bekleyen</div></div>
        <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--yesil)' }}>{izinler.filter(i => i.durum === 'onaylandi').length}</div><div className="stat-etiket">Onaylanan</div></div>
        <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--kirmizi)' }}>{izinler.filter(i => i.durum === 'reddedildi').length}</div><div className="stat-etiket">Reddedilen</div></div>
      </div>

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ padding: '1rem 1.25rem', borderBottom: '1px solid var(--border)', display: 'flex', gap: '8px' }}>
          {[{key:'bekliyor',label:'Bekleyenler'},{key:'onaylandi',label:'Onaylananlar'},{key:'reddedildi',label:'Reddedilenler'},{key:'hepsi',label:'Hepsi'}].map(f => (
            <button key={f.key} className={'btn btn-sm ' + (filtre === f.key ? 'btn-primary' : 'btn-secondary')} onClick={() => setFiltre(f.key)}>{f.label}</button>
          ))}
        </div>
        {filtrelenmis.length === 0 ? (
          <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--yazi-ikincil)' }}>Talep bulunamadı.</div>
        ) : (
          <div className="tablo-wrapper">
            <table>
              <thead><tr><th>Personel</th><th>İzin Türü</th><th>Başlangıç</th><th>Bitiş</th><th>Gün</th><th>Durum</th><th>İşlem</th></tr></thead>
              <tbody>
                {filtrelenmis.map(i => (
                  <React.Fragment key={i.id}>
                    <tr>
                      <td>
                        <div style={{ fontWeight: '500' }}>{i.personel_ad}</div>
                        <div style={{ fontSize: '12px', color: 'var(--yazi-ikincil)' }}>{i.personel_email}</div>
                      </td>
                      <td>{i.izin_turu}</td>
                      <td style={{ fontSize: '13px' }}>{fmt(i.baslangic_tarihi)}</td>
                      <td style={{ fontSize: '13px' }}>{fmt(i.bitis_tarihi)}</td>
                      <td style={{ fontSize: '13px' }}>{i.gun_sayisi}</td>
                      <td><span className={'badge ' + (durumRenk[i.durum] || 'badge-bekliyor')}>{durumEtiket[i.durum] || i.durum}</span></td>
                      <td>
                        {i.durum === 'bekliyor' && (
                          <button className="btn btn-secondary btn-sm" onClick={() => { setKararPanel(kararPanel === i.id ? null : i.id); setOnayNotu(''); }}>
                            Karar Ver
                          </button>
                        )}
                      </td>
                    </tr>
                    {kararPanel === i.id && (
                      <tr>
                        <td colSpan={7} style={{ background: 'var(--gri-50)', padding: '1rem' }}>
                          <div className="form-group" style={{ marginBottom: '0.75rem' }}>
                            <label>Onay Notu (isteğe bağlı)</label>
                            <input type="text" value={onayNotu} onChange={e => setOnayNotu(e.target.value)} placeholder="Açıklama ekleyin..." />
                          </div>
                          <div style={{ display: 'flex', gap: '8px' }}>
                            <button className="btn btn-primary" disabled={yukleniyor} onClick={() => handleKarar(i.id, 'onaylandi')}>✓ Onayla</button>
                            <button className="btn btn-danger" disabled={yukleniyor} onClick={() => handleKarar(i.id, 'reddedildi')}>✗ Reddet</button>
                            <button className="btn btn-secondary" onClick={() => setKararPanel(null)}>İptal</button>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};
export default IzinOnayPage;
